export enum DropDownViewCloseType {
  Route = 'route',
  DropDown = 'dropDown'
}

export enum DropDownViewCloseAction {
  Back = 'back',
  Close = 'close'
}

export enum DropDownViewSlide {
  Left = 'left',
  Top = 'top',
}
